import React, {useCallback, useEffect, useRef, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { activeMenu} from '@reducers/UserAppAction'
import AuthProvider from '@user-provider/AuthProvider'
import PrimaryAvatar from "./PrimaryAvatar";
import CustomerAvatar from "./CustomerAvatar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import {ClickAwayListener, Grow, IconButton, MenuList, MenuItem, Paper, Popper} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useCookies } from 'react-cookie';
import SocketProvider from "../provider/SocketProvider";
import AppAvatar from "./AppAvatar";
import clsx from "clsx";
import {appProfileButtonStore} from "../store/headerStore";
import {useRecoilState} from "recoil";

const NavBar = (props) => {
    const ignoreNavBar = ['waiting-app','/login' , '/join' , '/loginHelp', '/profile', '/editProfile', '/joinDone', 'waiting-device', 'update-report', '/measureFFT','/measureBand' ,'/measure/','/manage/customer', 'reset-password', '/gateway' ]
    
    //네비 화면 여부 
    let showNaviBar = true
    let useAppHeader = false
    for(let i = 0 ; i < ignoreNavBar.length; i++){
        const url = ignoreNavBar[i]
        if( -1 < props.location.pathname.indexOf(url) ){
            showNaviBar = false
            break
        }
    }
    
    if(-1 < props.location.pathname.indexOf('/exercise/')){
        showNaviBar = false
    }
    
    // 앱 특정 모드일 때 
    if(AuthProvider.isAppMode() && AuthProvider.getServiceType()){
        useAppHeader = true
    }
    
        
    return (
        !showNaviBar 
        ? <></>
        : useAppHeader 
            ? <AppHeader {...props}/>
            : <DefaultHeader {...props}/>
    )
}

const AppHeader = () => {
    const [showProfileButton] = useRecoilState(appProfileButtonStore);
    return (
        <>
          {AuthProvider.isProfileSelectorView() && showProfileButton &&
            <div className="name app-back-profile" style={{position: "absolute", left:30, top:30, zIndex: 99}}>
              <HeaderCustomerView color={'white'}/>
            </div>
          }
          <div className="name" style={{position: "absolute", right:30, top:30, zIndex: 99}}>
              <AppAvatar/>
          </div>
        </>
    )
}

const DefaultHeader = (props) => {
    return (
        <header id={'header'}>
            {AuthProvider.isCustomerView() || AuthProvider.isProfileSelectorView()
                ? <HeaderCustomerView />
                : <HeaderLogo />
            }
            <CenterMenu {...props} />
            <div className="name">
                {(AuthProvider.isCustomerView() || AuthProvider.isProfileSelectorView())
                    ? <CustomerAvatar />
                    : <PrimaryAvatar />
                }
            </div>
        </header>
    )
}

export function HeaderLogo(props) {
    const history = useHistory()
    const classes = useStyles()
    return (
        <h1>
            <a href="#" className={classes.logo} onClick={() => {
                if(props.click){
                    props.click()
                } else {
                    history.replace('/')
                }
            }}>브레인헬스(주)</a>
        </h1>
    )
}

export function HeaderCustomerView(props){
    const classes = useStyles()
    const history = useHistory()
    const [,setCookie] = useCookies()

    const clearSession = () => {
        if(AuthProvider.isCustomerView() || AuthProvider.isProfileSelectorView()){
            const originalCookie = localStorage.getItem(AuthProvider.userAdminCookieName)
          
            setCookie(AuthProvider.userCookieName, originalCookie , AuthProvider.getCookieOption())
            
            if(AuthProvider.isCustomerView() ){
              localStorage.removeItem(AuthProvider.userAdminCookieName)  
            }
            AuthProvider.clearCustomer()
        }
    };

    /**
     * profile-selector는 처리하지 않습니다 
     * 새로고침 해도 계속 쿠키를 유지해야하기때문
     */
    const clearSessionBeforeUnload = () => {
      //앱모드 일경우도 profile selector 타입이면 쿠키를 삭제하지 않습니다
      if(AuthProvider.isAppMode() && AuthProvider.isProfileSelectorView()) return;
      
      if(AuthProvider.isCustomerView() || AuthProvider.isAppMode()){
        clearSession()
      }
    };
    
    useEffect(() => {
        window.addEventListener("beforeunload", clearSessionBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", clearSessionBeforeUnload);
        }
    },[])
    
    return (
        <h1 style={{marginTop: -15}}>
            <IconButton
                className={clsx(classes.back, {
                  'text-white': !!props.color 
                })}
                aria-label="delete"
                onClick={async ()=>{
                    
                    let returnUrl = '/manage/customer'
                    if(AuthProvider.isProfileSelectorView()) {
                      returnUrl = '/profile-selector'
                    }
                    
                    clearSession()
                    SocketProvider.disconnect()
                  
                    history.replace(returnUrl)
                }}
            >
                <ArrowBackIcon style={{fontSize: 50}}/>
            </IconButton>
        </h1>
    )
}

//센터 메뉴를 표시합니다.
export function CenterMenu(props) {
    const [currentPath, setCurrentPath] = useState('')
    const [visibleCount, setVisibleCount] = useState(0)
    const [moreOpen, setMoreOpen] = useState(false)
    const moreRef = useRef(null)
    const navRef = useRef(null)

    const pathname = window.location.pathname

    // 메뉴가 필요없는 페이지
    const ignoreMenu = ['/login', '/loginHelp', '/profile', '/editProfile' ]
    const isIgnored = ignoreMenu.some(url => -1 < pathname.indexOf(url))

    const userRole = AuthProvider.getRole()
    let menu = props.menu.filter(m => m.role.includes(userRole))

    /**
     * 측정전용 아이디 일경우 사용 
     */
    if(AuthProvider.isProfileSelectorView()){
      menu = props.menu.filter( m => m.profileSelectView)
    }

    const menuLength = menu.length

    const calcVisibleCount = useCallback(() => {
        // 로고 영역(좌 240px) + 아바타 영역(우 240px) + 더보기 버튼(50px) + 여유
        const availableWidth = window.innerWidth - 240 - 240 - 50
        const menuItemWidth = 140 // 메뉴 항목 평균 너비
        const count = Math.floor(availableWidth / menuItemWidth)
        setVisibleCount(Math.max(0, Math.min(count, menuLength)))
    }, [menuLength])

    useEffect(() => {
        calcVisibleCount()
        window.addEventListener('resize', calcVisibleCount)
        return () => window.removeEventListener('resize', calcVisibleCount)
    }, [calcVisibleCount])

    if (isIgnored) return <></>

    const visibleMenu = menu.slice(0, visibleCount)
    const overflowMenu = menu.slice(visibleCount)

    return  (
            <nav ref={navRef}>
                <ul id="gnb">
                {visibleMenu.map((value, index) => {
                    return (
                        <li key={index}>
                            <Link to={value.url}
                                  className={-1 < pathname.indexOf(value.url) ? "active" : ""}
                                  onClick={() => {
                                      setCurrentPath(currentPath + pathname)
                                  }}
                            >
                                {value.name}
                            </Link>
                        </li>
                    ) 
                })}
                {overflowMenu.length > 0 && (
                    <li key="more"
                        style={{verticalAlign: 'middle'}}
                        onMouseEnter={() => setMoreOpen(true)}
                        onMouseLeave={() => setMoreOpen(false)}
                    >
                        <IconButton
                            ref={moreRef}
                            onClick={() => setMoreOpen(prev => !prev)}
                            style={{marginTop: 16}}
                        >
                            <MoreHorizIcon />
                        </IconButton>
                        <Popper open={moreOpen} anchorEl={moreRef.current} transition placement="bottom-end" style={{zIndex: 100}}>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper
                                        elevation={4}
                                        onMouseEnter={() => setMoreOpen(true)}
                                        onMouseLeave={() => setMoreOpen(false)}
                                    >
                                        <ClickAwayListener onClickAway={() => setMoreOpen(false)}>
                                            <MenuList>
                                                {overflowMenu.map((value, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        component={Link}
                                                        to={value.url}
                                                        selected={-1 < pathname.indexOf(value.url)}
                                                        onClick={() => {
                                                            setMoreOpen(false)
                                                            setCurrentPath(currentPath + pathname)
                                                        }}
                                                    >
                                                        {value.name}
                                                    </MenuItem>
                                                ))}
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </li>
                )}
                </ul>
            </nav>
    )
}


const mapStateToProps = state => {
    return { menu: state.UserAppReducer.menu }
}

const mapDispatchToProps = dispatch => {
    return {
        activeMenu: (url) => {
            dispatch(activeMenu(url))
        }
    }
}

const useStyles = makeStyles(() => ({
    logo: {
        backgroundImage: `url(${require('@images/logo.png')})`
    },
    back: {
        '&:hover': {
            backgroundColor: '#ededed',
        }
    },
    colorWhite: {color: "white !important"},
    dropMenu: {
        height: 300,
        background: '#fff',
        '&:hover': {
            height: 300,
        },
        transitionDelay: '0.3s'
    }
}));


export default connect(mapStateToProps, mapDispatchToProps)(NavBar)
